"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleFullscreen = exports.closeFullscreen = exports.openFullscreen = exports.isFullscreen = void 0;
function isFullscreen() {
    const doc = document;
    return !!(doc.fullscreenElement ||
        doc.mozFullScreenElement ||
        doc.webkitFullscreenElement ||
        doc.msFullscreenElement);
}
exports.isFullscreen = isFullscreen;
/* MANAGING FULLSCREEN */
function openFullscreen(element) {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    }
    else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    }
    else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
    else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    }
}
exports.openFullscreen = openFullscreen;
function closeFullscreen(doc) {
    if (doc.exitFullscreen) {
        doc.exitFullscreen();
    }
    else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
    }
    else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
    }
    else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
    }
}
exports.closeFullscreen = closeFullscreen;
function toggleFullscreen(elem = document.documentElement) {
    if (!isFullscreen()) {
        openFullscreen(elem);
    }
    else {
        closeFullscreen(document);
    }
}
exports.toggleFullscreen = toggleFullscreen;
//# sourceMappingURL=utils.js.map